var map = {
	"./swiper-img1.png": "fuDz",
	"./swiper-img2.png": "Gpcl",
	"./swiper-img3.png": "J3SD",
	"./swiper-img4.png": "PSi2",
	"./swiper-img5.png": "8baJ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6jHp";